import React, {useEffect, useState} from 'react';

import styles from './DeliveryShippingAddress.module.css'

import {Input} from "../../../../../../../../ui/DataEntry/Input/Input.tsx";
import {cn} from "../../../../../../../../utils/cn.ts";
import {TextArea} from "../../../../../../../../ui/DataEntry/TextArea/TextArea.tsx";
import {Order} from "../../../../../../../../types/Order.interface.ts";
import {Address, DeliveryType} from "../../../../../../../../types/Delivery.interface.ts";
// import { useMultiStorage } from '../../../../../../../../hooks/useStorage.ts';
import { API_URL } from '../../../../../../../../config.tsx';
import { RootState, useAppSelector } from '@/utils/storage/stores/store.ts';

interface Props {
    onAddressChange: (address: Address, isUpdate: boolean , changeBranch: boolean, deliveryType: string|null) => void,
}

export const DeliveryShippingAddress: React.FC<Props> = ({onAddressChange}) => {
    const [postcode, setPostcode] = useState<string>('');
    const [townName, setTownName] = useState<string>('');
    const [searchTownName, setSearchTownName] = useState<string>('');
    const [street, setStreet] = useState<string>('');
    const [streetNumber, setStreetNumber] = useState<string>('');
    const [apartmentNumber, setApartmentNumber] = useState<string>('');
    const [comment, setComment] = useState<string>('');
    const [transportCompanyAlias, setTransportCompanyAlias] = useState<string>('');
    const [controllers, setControllers] = useState([]);
    const [offer, setOffer] = useState<Order|null>(null);
    const [regularCities, setRegularCities] = useState([]);
    const cartOffer = useAppSelector((state: RootState) => state.cart.cartOffer);
    const address = {
        postcode: postcode || '',
        city: townName || '',
        townId: 0,
        street: street || '',
        streetNumber: streetNumber || '',
        apartmentNumber: apartmentNumber || ''
    };

    const disabledChangeAddress = transportCompanyAlias === '100_sp';
    // const storage = useMultiStorage({
    //     cartOffer: ['cartOffer', offer],
    //   })[0];

      const handleAbort = () => {
        controllers.map(controller => {
            // @ts-ignore
            controller.abort();
        })
    }

    const findTown = (query: any) => {
        if(!query) {
            setRegularCities([]);
            return;
        }
        handleAbort();
        let newControllersList = controllers;
        const abortController = new AbortController();
        // @ts-ignore
        newControllersList.push(abortController);
        setControllers(newControllersList);
        fetch(`${API_URL}/find_town?query=${query}`, {
            method: 'GET',
            credentials: 'include',
            signal: abortController.signal
        })
            .then(response => response.json())
            .then(data => setRegularCities(data))
    }

    const changeSearchTownName = (value: string) => {
        findTown(value);
        setSearchTownName(value);
    }

    const changeDeliveryComment = (comment: string) => {
        if(!offer) return;
        setComment(comment);
        fetch(`${API_URL}/cart/${offer.cartId}/change_delivery_comment`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({comment}),
        })
    }



    const selectTown = (townId: number, city: string) => {
        setSearchTownName(city);
        findTown('');
        onAddressChange({...address, city, townId}, false, false, DeliveryType.shipping);
    }

    const  changePostcode = (postcode: string) => {
        setPostcode(postcode);
        onAddressChange({...address, postcode}, false, false, DeliveryType.shipping)
    }

    const  changeStreet = (street: string) => {
        setStreet(street);
        onAddressChange({...address, street}, false, false, DeliveryType.shipping)
    }

    const  changeStreetNumber = (streetNumber: string) => {
        setStreetNumber(streetNumber);
        onAddressChange({...address, streetNumber}, false, false, DeliveryType.shipping)
    }

    const  changeApartmentNumber = (apartmentNumber: string) => {
        setApartmentNumber(apartmentNumber);
        onAddressChange({...address, apartmentNumber}, false, false, DeliveryType.shipping)
    }

    useEffect(() => {
        if(cartOffer) {
            setOffer(cartOffer);
            setPostcode(cartOffer.delivery.postcode || '')
            setTownName(cartOffer.delivery.townName || '')
            setSearchTownName(cartOffer.delivery.townName || '')
            setStreet(cartOffer.delivery.street || '')
            setStreetNumber(cartOffer.delivery.house || '')
            setApartmentNumber(cartOffer.delivery.apartment || '')
            setComment(cartOffer.delivery.comment || '')
            setTransportCompanyAlias(cartOffer.delivery.company?.alias || '')
        }
    }, [cartOffer]);

    if(!offer) return null;

    return (
        <div>
            <div>
                <h4 className={styles.title}>Адрес доставки</h4>
                <div className={styles.inputs}>
                    <Input
                        className={cn(styles.input, styles.postcode)}
                        label='Индекс'
                        value={postcode}
                        disabled={disabledChangeAddress}
                        changeStateValue={changePostcode}
                    />
                    <Input
                        className={cn(styles.input, styles.city)}
                        label='Город'
                        value={searchTownName}
                        disabled={disabledChangeAddress}
                        changeStateValue={changeSearchTownName}
                        selectListData={selectTown} list={regularCities}
                    />
                    <Input
                        className={cn(styles.input, styles.street)}
                        label='Улица'
                        value={street}
                        disabled={disabledChangeAddress}
                        changeStateValue={changeStreet}
                    />
                    <Input
                        className={cn(styles.input, styles.streetNumber)}
                        label='Дом'
                        value={streetNumber}
                        disabled={disabledChangeAddress}
                        changeStateValue={changeStreetNumber}
                    />
                    <Input
                        className={cn(styles.input, styles.apartmentNumber)}
                        value={apartmentNumber}
                        disabled={disabledChangeAddress}
                        label='Кв./Офис'
                        changeStateValue={changeApartmentNumber}
                    />

                </div>
            </div>
            <div>
                <TextArea value={comment} onInput={changeDeliveryComment} cols={10} />
            </div>
        </div>
    );
};
